import { HTMLAttributes, PropsWithChildren } from 'react';
import { Button, ButtonProps, cn, Tooltip } from '@sib/ui';
import { CopyIcon } from '@spendbrain/icons';
import { useAppTranslation } from '@spendbrain/modules/yourTeam/hooks';
import { useCopyToClipboard } from '../hooks';

interface CopyToClipboardProps extends PropsWithChildren {
  value: string;
  ButtonProps?: ButtonProps;
  tooltipText?: string;
  ContainerProps?: HTMLAttributes<HTMLDivElement>;
}

export const CopyToClipboard = ({
  children,
  value,
  tooltipText,
  ButtonProps,
  ContainerProps,
}: CopyToClipboardProps) => {
  const { t } = useAppTranslation();
  const { handleCopy } = useCopyToClipboard();

  return (
    <Tooltip
      TooltipTriggerProps={{ asChild: true }}
      TooltipContentProps={{
        withArrow: true,
        sideOffset: -5,
      }}
      {...(tooltipText && {
        content: t('copyToClipboardTooltip', { text: tooltipText }),
      })}
    >
      <div
        {...ContainerProps}
        className={cn(
          'group flex w-fit items-center justify-center gap-2',
          ContainerProps?.className
        )}
      >
        <div onClick={() => handleCopy(value)} className="cursor-pointer">
          {children}
        </div>
        <Button
          variant="ghost"
          {...ButtonProps}
          onClick={e => {
            handleCopy(value);
            ButtonProps?.onClick?.(e);
          }}
          className={cn(
            'text-primary hover:bg-primary/10 hidden size-6 p-0 group-hover:flex',
            ButtonProps?.className
          )}
        >
          <CopyIcon className="size-4" />
        </Button>
      </div>
    </Tooltip>
  );
};
